import NoScheduleIcon from "Assets/Icons/NoScheduleIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { useMyBatchContext } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";
import TOCModal from "Pages/MySchedule/TOCModal/TOCModal";
import { Card } from "antd";
import {
  useContext,
  useState,
  useMemo,
  useCallback,
  memo,
  useEffect,
} from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import styled from "styled-components";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
export const HeaderTabDiv = styled<any>("div")`
  border-bottom: 1px solid #afafaf;
  flex-direction: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "column" : "row"};
  padding: 12px 24px 12px 12px !important;
  display: flex;
  height: 54px;
  align-items: flex-start;
`;
const MyBatchSyllabMainDiv = styled<any>("div")`
  padding: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "0px" : "0px 16px 0px 0px"};
  height: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen)
      ? "calc(100vh - 130px) !important"
      : "calc(100vh - 210px) !important"};
`;
export const LectureStyledSpan1 = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "16px"};
  color: #333333 !important;
  font-weight: 700;
`;
export const StyledSpan2 = styled<any>("span")`
  font-size: ${({ screen }: any) =>
    ["xs", "sm", "md"].includes(screen) ? "12px" : "16px"};
  color: #757575 !important;
`;
const CustomCard = styled<any>(Card)`
  .ant-card-body {
    padding: ${(props: any) =>
      ["xl", "xxl", "lg"].includes(props.screen) ? "16px" : "0px"};
  }
`;
interface MyBatchSyllabusTabIF {
  screen: any;
  item?: any;
  selectedCourseSyllabus: any;
  setSelectedCourseSyllabus?: any;
  argBatchId?: any;
}
const MyBatchSyllabusTab = memo(
  ({ screen, selectedCourseSyllabus, argBatchId }: MyBatchSyllabusTabIF) => {
    const { id: batchId } = useParams();
    const { batchDetailsData } = useMyBatchContext();
    const ToastDispatch = useContext<any>(ToastContextDispatch);
    const userInfo = useContext<any>(UserInfoContext);
    const [allCoveredTopics] = useState<any>([]);
    const [planneLecturedList, setplanneLecturedList] = useState<any>([]);
    const [plannedLecture, setplannedLecture] = useState<any>(null);
    useEffect(() => {
      setplanneLecturedList([]);
      setplannedLecture(null);
    }, [selectedCourseSyllabus]);
    const [ispaneopen, setIspaneOpen] = useState<boolean>(false);
    console.log(ispaneopen);
    const [loading, setLoading] = useState(false);
    const toggleModal = useCallback(() => {
      setIspaneOpen((prev) => !prev);
    }, []);
    const getPlannedLecture = useCallback(
      async (url: string) => {
        await getAPIRequest({
          url: url,
          success: (response: any) => {
            if (response && response["data"] && response["data"]["data"]) {
              setplanneLecturedList(
                response["data"]["data"]["plannedLectureIdList"]
              );
              setplannedLecture(response["data"]["data"]);
            } else {
              setplanneLecturedList([]);
              setplannedLecture([]);
            }
          },
          failure: (error: any) => {
            setplanneLecturedList([]);
            setplannedLecture([]);
            setLoading(false);
            ToastDispatch({
              isOpen: true,
              type: "Error",
              message:
                error?.response?.data?.code == "NF"
                  ? "No Topic Present for this lecture"
                  : error.message,
            });
          },
        } as getRequestInterface);
      },
      [ToastDispatch]
    );
    const modalCloseHandler = useCallback(() => {
      toggleModal();
    }, [toggleModal]);

    const headerElement = useMemo(
      () => (
        <HeaderTabDiv screen={screen}>
          <LectureStyledSpan1 screen={screen} className="pr-2">
            {selectedCourseSyllabus?.subj} | Topic List{" "}
          </LectureStyledSpan1>
          <StyledSpan2 screen={screen}>
            (Lecture Number, Lecture Date, Faculty)
          </StyledSpan2>
        </HeaderTabDiv>
      ),
      [screen, selectedCourseSyllabus?.subj]
    );

    const obj = useMemo(
      () => ({
        batchId: argBatchId ?? batchId,
        courseId: selectedCourseSyllabus?.courseId,
        subject: selectedCourseSyllabus?.subj,
        eventName: selectedCourseSyllabus?.eventName,
      }),
      [
        argBatchId,
        batchId,
        selectedCourseSyllabus?.courseId,
        selectedCourseSyllabus?.subj,
        selectedCourseSyllabus?.eventName,
      ]
    );
    console.log(
      "objobjobjobjobj",
      argBatchId,
      batchId,
      selectedCourseSyllabus?.courseId,
      selectedCourseSyllabus?.subj
    );
    return (
      <CustomCard screen={screen}>
        <MyBatchSyllabMainDiv screen={screen}>
          {loading ? (
            <div>
              <Spinner color="info"></Spinner>
            </div>
          ) : (
            <>
              {selectedCourseSyllabus == null ? (
                <div className="noDataFoundCSS">
                  <NoResultFoundSearch
                    primaryMessage="Syllabus information not available"
                    secondaryMessage={
                      "Subjects/course IDs not assigned to the batch corresponding to your subjects. Contact your EDP team for assistance."
                    }
                    divClassName={"noDataFoundCSSMB"}
                  >
                    <NoScheduleIcon />
                  </NoResultFoundSearch>
                </div>
              ) : (
                <TOCModal
                  key={`${selectedCourseSyllabus?.courseId}_${selectedCourseSyllabus?.subj}`}
                  mode="mybatchSyllabus"
                  selectedlecture={obj}
                  planneLecturedList={planneLecturedList}
                  allCoveredTopics={allCoveredTopics}
                  plannedLecture={plannedLecture}
                  toggleModal={toggleModal}
                  userInfo={userInfo}
                  getPlannedLecture={getPlannedLecture}
                  screen={screen}
                  setIspaneOpen={setIspaneOpen}
                  modalCloseHandler={modalCloseHandler}
                  header={headerElement}
                  ispaneopen={true}
                  batchName={batchDetailsData?.batchName}
                  subject={selectedCourseSyllabus?.subj}
                ></TOCModal>
              )}
            </>
          )}
        </MyBatchSyllabMainDiv>
      </CustomCard>
    );
  }
);
MyBatchSyllabusTab.displayName = "MyBatchSyllabusTab";
export default MyBatchSyllabusTab;
